import { Link, useNavigate } from "react-router-dom";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaSitemap,
  FaTiktok,
  FaWhatsapp,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import "./Footer.css";
import logo from "../../assets/trainosys300.png";

const socialLinks = [
  { label: "Facebook", href: "https://www.facebook.com/trainosys.sg", icon: <FaFacebookF /> },
  { label: "Instagram", href: "https://www.instagram.com/trainosystraining/?hl=en", icon: <FaInstagram /> },
  { label: "TikTok", href: "https://www.tiktok.com/@trainosys?lang=en", icon: <FaTiktok /> },
  { label: "X", href: "https://x.com/trainosys", icon: <FaXTwitter /> },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/trainosys-training-the-future-today-435401185/", icon: <FaLinkedinIn /> },
];

const trainingLinks = [
  "Corporate Training",
  "Remote Learning",
  "Classroom Programs",
  "Hybrid Delivery",
];

const popularCourses = ["Power BI", "SQL Server", "Python", "Cybersecurity"];

function Footer({ onCourseFilter }) {
  const navigate = useNavigate();

  function handleCourseFilter(course) {
    if (onCourseFilter) {
      onCourseFilter(course);
      return;
    }

    navigate(`/courses?search=${encodeURIComponent(course)}&page=1`);
  }

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <img src={logo} alt="Trainosys" className="footer-logo" />
          <p className="footer-description">
            Trainosys delivers enterprise-focused IT and business training
            solutions for local and international teams.
          </p>
          <div className="footer-socials">
            {socialLinks.map(({ label, href, icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4><Link to="/courses">Training</Link></h4>
          <ul>
            {trainingLinks.map((label) => (
              <li key={label}><Link to="/#delivery">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4><Link to="/#popular">Popular Courses</Link></h4>
          <ul>
            {popularCourses.map((course) => (
              <li key={course}>
                <button type="button" onClick={() => handleCourseFilter(course)}>
                  {course}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4><Link to="/contact">Contact</Link></h4>
          <ul className="footer-contact">
            <li>
              <FaEnvelope />
              <a href={`mailto:${["inquiry", "@", "trainosys.sg"].join("")}`}>
                inquiry@trainosys.sg
              </a>
            </li>
            <li>
              <FaWhatsapp />
              <a href="https://wa.me/6580910792" target="_blank" rel="noreferrer">
                +6580910792
              </a>
            </li>
            <li><FaMapMarkerAlt /> Singapore</li>
            <li>
              <FaSitemap />
              <a href="/sitemap.xml" target="_blank" rel="noreferrer">Sitemap</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          © {new Date().getFullYear()} Trainosys. All rights reserved.
          {" | "}<Link to="/terms-and-conditions">Terms and Conditions</Link>
          {" | "}<Link to="/privacy-policy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
